module.exports = ".mdl-data-table__cell--non-numeric_title{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n.close-btn-wrapper{\r\n    position:relative;  \r\n}\r\n.close{\r\n    position: relative;\r\n    cursor: pointer;\r\n    top: -19px;\r\n    right: -27px;\r\n    transition: all 200ms;\r\n    font-size: 26px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    color:#333;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/extra-pages/changelog/changelog.component.css
// module id = 968
// module chunks = 1